import FormItem from '@/components/Form/FormItem';
import React from 'react';
import { UseFormRegister, FieldErrors, Control } from 'react-hook-form';

type Props = {
  register: UseFormRegister<any>;
  errors: FieldErrors<any>;
  control: Control<any, any>;
};

export default function AgentBookingInfo({ register, errors }: Props) {
  return (
    <div className="row x-gap-10 y-gap-20 mt-20">
      <div className="col-12  ">
        <div className="d-flex align-items-center">
          <div className="fw-bold text-18 text-blue-1  rounded-2 pr-10 text-uppercase">Agent Remark</div>
          <div style={{ flex: 1, border: '1px dashed #cccccc' }} />
        </div>
      </div>

      <div className="col-md-6 col-xs-12">
        <FormItem errors={errors} label="Agent booking ref" name="agentBookingRef">
          <input {...register('agentBookingRef')} />
        </FormItem>
      </div>
    </div>
  );
}
